<template>
    <AppLayout
        ref="layout"
        page="/myschedule"
        pageTitle="Lessons"
        :tabs="true"
        :filterData="filterData"
        :showBanner="showBanner"
        @filterResults="returnFilterResults"
    >
        <template #tabs
            ><v-tabs background-color="transparent" v-model="selectedTab">
                <v-tab class="no-link" href="/myschedule/upcoming">
                    <Link
                        class="no-link flex align-center justify-center min-h-full"
                        href="/myschedule/upcoming"
                        preserve-state
                        :only="['lessons', 'loadMore']"
                        >Upcoming</Link
                    >
                </v-tab>

                <v-tab class="no-link" href="/myschedule/past">
                    <Link
                        class="no-link flex align-center justify-center min-h-full"
                        href="/myschedule/past"
                        preserve-state
                        :only="['pastLessons', 'loadMore']"
                        >Past</Link
                    >
                </v-tab>
            </v-tabs></template
        >

        <v-container :class="$vuetify.breakpoint.xs ? 'px-0' : null">
            <StudentBookingPanel
                :user="auth.user"
                :sharedSubscriptions="sharedSubscriptions"
                @bookNow="handleBookNow($event)"
                :hasFutureLessons="hasFutureLessons"
                :hasPastLessons="hasPastLessons"
                :hasCancelledLessons="hasCancelledLessons"
                @contactStudio="contactStudio = true"
                :activeMemberships="activeMemberships"
                :disabled="disabled"
                :apiLoading="
                    apiLoading && $refs.createLesson?.stepNumber <= 1
                " />
            <!--<ContactStudio
                :location="$page.props.auth.user.selected_location"
                @reset="closeModal(() => (contactStudio = false))"
                v-if="contactStudio" />-->
            <!--<SoliResponsiveDialog
                ref="locationContact"
                v-if="contactStudio"
                @reset="closeModal(() => (contactStudio = false))"
                title="Contact Us!"
                ><template #body>
                    <ContactStudio
                        :location="$page.props.auth.user.selected_location"
                /></template>
            </SoliResponsiveDialog>-->
            <SoliResponsiveDialog
                ref="locationContact"
                v-if="contactStudio"
                @reset="closeModal(() => (contactStudio = false))"
                title="Contact Us!"
                ><template #body>
                    <SoliLocations
                        :parentLocations="$page.props.auth.user.locations"
                        :value="$page.props.auth.user.selected_location"
                        iterator
                        showAddress
                        hideDetails
                        expandable
                        hideSearch
                /></template>
            </SoliResponsiveDialog>
            <div :class="$vuetify.breakpoint.xs ? 'px-1' : null">
                <v-tabs-items v-model="selectedTab">
                    <v-tab-item value="/myschedule/upcoming">
                        <LessonPanels
                            :disabled="disabled"
                            class="animate__animated animate__fadeIn"
                            :lessons="getLessons"
                            :activeMemberships="activeMemberships"
                            :relationships="relationships"
                            :loadMore="loadMore"
                            @reschedule="handleBookMySchedule($event)"
                            @cancel="confirmCancelAlert = $event"
                            @move="confirmMove = $event"
                        />
                    </v-tab-item>

                    <v-tab-item value="/myschedule/past">
                        <LessonPanels
                            :disabled="disabled"
                            class="animate__animated animate__fadeIn"
                            :lessons="getPastLessons"
                            isPast
                            :activeMemberships="activeMemberships"
                            :relationships="relationships"
                            :loadMore="loadMore"
                            @cancel="confirmCancelAlert = $event"
                            @reschedule="handleBookMySchedule($event)"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </div>
            <v-skeleton-loader
                v-if="loading"
                class="mx-4"
                type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line"
            ></v-skeleton-loader
        ></v-container>
        <SoliChoice
            title="Heads up!"
            :subtitle="confirmCancelAlert.warning"
            @option1="confirmCancel(confirmCancelAlert)"
            button1="Confirm"
            button2="Nevermind"
            @reset="confirmCancelAlert = null"
            v-if="confirmCancelAlert"
        ></SoliChoice>
        <SoliChoice
            title="Are you sure?"
            :subtitle="`Your lesson on ${globalMomentDateShort(
                new Date(confirmMove.starts_at)
            )} will be moved ${
                confirmMove.online ? `In-person` : 'Online'
            } and your teacher will be notified.`"
            button1="Confirm"
            loading1
            @option1="moveOnline(confirmMove)"
            button2="Nevermind"
            @reset="confirmMove = false"
            v-if="confirmMove"
        ></SoliChoice>

        <SoliSnack
            v-if="showMessage"
            @hide="showMessage = false"
            :text="$page.props.successMessage"
        ></SoliSnack>

        <CreateLesson
            v-if="clickData"
            ref="createLesson"
            :errors="errors"
            :event="clickData"
            :bookingSource="bookingSource"
            :relationships="relationships"
            @apiLoading="apiLoading = $event"
            @reset="closeModal(() => (clickData = null))"
            @success="handleSuccess"
        />

        <!--<BookingCreate
            v-if="clickData && $page.props.auth.user.virtual_client"
            :errors="errors"
            :event="clickData"
            :bookingSource="bookingSource"
            :relationships="relationships"
            @reset="clickData = null"
            @success="handleSuccess"
        />-->

        <Contracts
            v-if="loadContract"
            :contracts="loadContract.unsignedContract"
            :client="auth.user"
            :purchaseOption="loadContract"
            :key="loadContract.id"
            @success="handleContractSuccess()"
            @reset="handleContractReset()"
        ></Contracts>
        <SoliChoice
            permanent
            v-if="showContract"
            title="Heads up"
            subtitle="You have recently purchased a pass or membership with Musicologie. Please agree to the terms to continue"
            button1="View Agreement"
            @option1="loadContract = unsignedContracts[0]"
            @reset="showContract = false"
        ></SoliChoice>

        <SoliForm
            v-if="viewNotes"
            :title="`Lesson Notes for ${globalMomentDateShort(viewNotes.date)}`"
            :saveChanges="false"
            hideBtn
            @reset="viewNotes = null"
        >
            <template #body>
                <v-textarea
                    ref="notes"
                    outlined
                    dense
                    class="soli-round"
                    :label="`What we worked on during this lesson:`"
                    :value="viewNotes.lessonNote"
                    readonly
                ></v-textarea>
                <v-textarea
                    outlined
                    dense
                    class="soli-round"
                    :label="`What ${
                        viewNotes.student.id == $page.props.auth.user.id
                            ? 'you'
                            : viewNotes.student.first_name
                    } should work on at home:`"
                    :value="viewNotes.practiceNote"
                    readonly
                ></v-textarea>
            </template>
        </SoliForm>
    </AppLayout>
</template>

<script>
import AppLayout from "./../Layouts/AppLayout";
//import SoliChoice from "./../Components/Base/SoliChoice"
import Contracts from "./../Components/Store/Contracts";
import CreateLesson from "./../Components/Booking/CreateLesson.vue";
import ContactStudio from "./../Components/MySchedule/ContactStudio.vue";
import LessonPanels from "./../Components/MySchedule/LessonPanels.vue";
import StudentBookingPanel from "./../Components/MySchedule/StudentBookingPanel.vue";
import { Link } from "@inertiajs/vue2";
import globalMoment from "../Mixins/GlobalMoment";
//import BookingCreate from "./../Components/MySchedule/Booking/BookingCreate.vue";

export default {
    mixins: [globalMoment],
    components: {
        AppLayout,
        Contracts,
        CreateLesson,
        ContactStudio,
        LessonPanels,
        StudentBookingPanel,
        Link,
        //BookingCreate,
        //SoliChoice
    },
    props: {
        lessons: {
            type: Array,
            default: () => [],
        },
        errors: {},
        pastLessons: {
            type: Array,
            default: () => [],
        },
        //assignments: {},
        //locations: {},
        relationships: {},
        auth: {},
        sharedSubscriptions: {},
        hasPastLessons: {},
        hasFutureLessons: {},
        hasCancelledLessons: {},
        loadMore: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            loading: false,
            apiLoading: false,
            lessonIdx: null,
            selectedTab: window.location.pathname,
            clickData: null,
            bookingSource: {},
            filterData: null,
            filterByRelation: null,
            confirmMove: false,
            loadContract: false,
            showContract: false,
            showMessage: false,
            contractTotal: false,
            viewNotes: null,
            //apiLessons: [],
            //apiPastLessons: [],
            //apiCancelledLessons: [],
            //apiLessonsLoading: false,
            activeMemberships: [],
            confirmCancelAlert: null,
            contactStudio: false,
        };
    },
    computed: {
        unsignedContracts() {
            return this.sharedSubscriptions.filter((e) => e.unsignedContract);
        },
        showBanner() {
            if (!this.sharedSubscriptions.length) return [];
            this.activeMemberships = this.sharedSubscriptions.filter(
                (e) =>
                    e.category == "memberships" &&
                    (moment(e.ends_at).isAfter(moment()) || !e.ends_at)
            );
            let memberships = this.activeMemberships.filter(
                (e) => e.user_id == this.auth?.user?.id
            );
            return [
                {
                    show: !!this.getPastDueInvoice,
                    message:
                        "Your membership is currently past due. Please update your payment information.",
                    button: "Pay Now",
                    addCreditCard: false,
                    invoice: {
                        user_id: this.auth?.user?.id,
                        subscription_id: this.getPastDueInvoice
                            ? this.getPastDueInvoice.subscription_id
                            : null,
                    },
                },
                {
                    show: memberships.length && !this.auth?.user?.paymentMethod,
                    message:
                        "You have an active membership, but no payment information on file. One is required to make scheduling changes.",
                    button: "Add Payment Method",
                    addCreditCard: true,
                },
            ];
        },
        disabled() {
            return Object.values(this.showBanner).some((e) => e.show);
        },
        getPastDueInvoice() {
            let subscriptions = this.sharedSubscriptions.filter(
                (e) => e.subscription_item
            );
            if (!subscriptions.length) return false;
            return subscriptions
                .flatMap((e) => e.subscription_item)
                .find(
                    (e) =>
                        e.subscription.stripe_status == "past_due" ||
                        e.subscription.stripe_status == "unpaid"
                );
        },
        today() {
            return moment(new Date()).format("llll");
        },
        mobile() {
            return this.$vuetify.breakpoint.xs;
        },
        getPastLessons() {
            if (!this.filterByRelation) return this.pastLessons;
            return this.pastLessons.filter((e) =>
                this.filterByRelation.map((i) => i.id).includes(e.student.id)
            );
        },
        getLessons() {
            if (!this.filterByRelation) return this.lessons;
            return this.lessons.filter((e) =>
                this.filterByRelation.map((i) => i.id).includes(e.student.id)
            );
        },
    },
    methods: {
        handleContractSuccess() {
            this.$refs.layout.showMessage = true;
            if (!this.unsignedContracts.length) return;
            this.loadContract = this.unsignedContracts[0];
        },
        handleContractReset() {
            if (this.unsignedContracts.length) return;
            this.closeModal(() => (this.loadContract = false));
        },
        handleBookNow(event) {
            this.bookingSource.isMySchedule = false;
            this.bookingSource.isSelfServe = true;
            this.clickData = event;
        },
        handleBookMySchedule(event) {
            this.bookingSource.isMySchedule = true;
            this.bookingSource.isSelfServe = false;
            this.clickData = event;
        },
        loadNotes(item) {
            this.viewNotes = {
                lessonNote: item.attendance.lesson_note,
                practiceNote: item.attendance.practice_note,
                student: item.student,
                date: item.starts_at,
            };
        },
        returnFilterResults(res) {
            this.filterByRelation = res;
        },
        moveOnline(event) {
            this.$inertia.put(
                `/lesson/${event.id}`,
                {
                    online: event.online ? false : true,
                },
                {
                    preserveScroll: true,
                    preserveState: true, //page => Object.keys(page.props.errors).length,
                    onSuccess: () => {
                        this.showMessage = true;
                        this.confirmMove = false;
                    },
                }
            );
        },
        confirmCancel(lesson) {
            this.$inertia.put(`/lesson/${lesson.event.id}`, lesson.status, {
                preserveScroll: true,
                preserveState: true, //page => Object.keys(page.props.errors).length,
                onSuccess: () => {
                    this.showMessage = true;
                },
            });
        },
        handleSuccess() {
            this.showMessage = true;
            this.closeModal(() => (this.clickData = null));
            this.bookingSource = {};
            //this.$refs.NewLessonDialog.reset();
        },
    },
    mounted() {
        this.filterData = this.relationships;
        if (this.unsignedContracts.length) {
            this.showContract = true;
        }
    },
    /*watch: {
        clickData(val) {
            if (val && this.$page.props.auth.user.virtual_client) {
                this.$inertia.visit(route("myschedule.booking"));
            }
        },
    },*/
};
</script>
